import Vue from 'vue'

Vue.directive('auto-height', (el) => {
  function resize () {
    this.style.height = 'auto'

    if (this.scrollHeight) {
      this.style.height = `${this.scrollHeight}px`
    }
  }

  el.addEventListener('input', resize, false)

  resize.call(el)
})
